import React from 'react';
import Dropzone from 'react-dropzone';
import './AddPhotos.css';


const MAX_FILE_SIZE = 20971520;
const ACCEPTED_FILE_TYPES = 'image/jpeg, image/jpg, image/png, image/gif';

class AddPhotos extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Dropzone
        accept={ACCEPTED_FILE_TYPES}
        maxSize={MAX_FILE_SIZE}
        onDrop={this.props.onDrop}
        onDropRejected={this.props.onDropRejected}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <span>Add Images</span>
          </div>
        )}
      </Dropzone>
    );
  }
}

export default AddPhotos;
